<template>
    <multiselect
        v-model="internalValue"
        :options="filteredOptions"
        :multiple="true"
        :taggable="true"
        :disabled="disabled"
        :show-pointer="false"
        :show-no-results="false"
        :show-no-options="false"
        selected-label=""
        deselect-label=""
        select-label=""
        placeholder=""
        :internal-search="false"
        open-direction="bottom"
        @search-change="onSearchChange"
        @tag="handleTag"
    >
    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { convertToHalfsize } from '@/utils/format';

export default {
    name: 'CommonMultiselect',
    components: { Multiselect },
    props: {
        value: {
            type: [Array, String],
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchQuery: ''
        };
    },
    computed: {
        internalValue: {
            get() {
                return Array.isArray(this.value) ? this.value : [];
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        filteredOptions() {
            if (!this.searchQuery) return this.options;
            const normalizedQuery = convertToHalfsize(this.searchQuery).toLowerCase();
            return this.options.filter((option) => {
                const label = option?.name || option || '';
                const normalizedLabel = convertToHalfsize(label).toLowerCase();
                return normalizedLabel.includes(normalizedQuery);
            });
        }
    },
    methods: {
        onSearchChange(searchQuery) {
            this.searchQuery = searchQuery;
        },
        handleTag(newTag) {
            const newOptions = [...this.options, newTag];
            this.$emit('update:options', newOptions);
            const currentValue = Array.isArray(this.value) ? this.value : [];
            const newValue = [...currentValue, newTag];
            this.$emit('input', newValue);
        }
    }
};
</script>
